<template>
  <v-container fluid align-start ma-0 pa-2 class="epms9112-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                  @btnRetrieve="btnRetrieve()"
                  @btnExcel="btnExcel()"          
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Ship No. : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line                            
                            outlined
                            dense
                            label="Select"
                            @change="shipNoChange()"
                          ></v-select>
                      </v-col>
                      <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Por No. : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="porNo"
                            :items="porNoList"
                            item-value="porNo"
                            return-object
                            single-line
                            outlined
                            dense
                            label="Select"
                            @change="porNoChange()"
                          ></v-select>
                      </v-col>

                      <!-- <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">PSD from : </span>
                      <v-col cols="1">
                        <DxDateBox
                          :value="stDte"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col> -->
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms9112" 
                    class="hipGridHeight1_1" 
                    :ref="epms9112Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="shipNo" caption="Ship No." width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="porNo" caption="POR No." width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="lineNo" caption="Seq" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="dwgNo" caption="Drawing No." width="6%" data-type="string" alignment="center" header-cell-template="drawingHeaderTemp" :allow-editing="false"/>
                    <template #drawingHeaderTemp><div> Drawing <br>No.</div></template>
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="partNo" caption="PIECE No." width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="dia" caption="DIA" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="pipeMatl" caption="Schedule of Pipe" width="10%" data-type="string" alignment="center" header-cell-template="schHeaderTemp" :allow-editing="false"/>
                    <template #schHeaderTemp><div> Schedule <br>of Pipe</div></template>
                    <DxColumn data-field="treatCode" caption="Treatment Code" width="8%" data-type="string" alignment="center" header-cell-template="treatCodeHeaderTemp" :allow-editing="false"/>
                    <template #treatCodeHeaderTemp><div> Treatment<br>Code</div></template>
                    <DxColumn data-field="paintCode" caption="Paint Code" width="8%" data-type="string" alignment="center" header-cell-template="paintCodeHeaderTemp" :allow-editing="false"/>
                    <template #paintCodeHeaderTemp><div> Paint<br>Code</div></template>
                    <DxColumn data-field="cls" caption="Class" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="insp" caption="Inspection" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="press" caption="Pressure(KG/CM2)" width="8%" data-type="string" alignment="center" header-cell-template="pressHeaderTemp" :allow-editing="false"/>
                    <template #pressHeaderTemp><div> Pressure<br>(KG/CM2)"</div></template>
                    <DxColumn data-field="wgt" caption="Weight" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxPaging :enabled="true" :page-size="60" />
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epms9112, epms9112Xls} from '@/api/view/hip/91/epms9112'
import { epms9000_por_no, getShipNoList1 } from '@/api/view/hip/common/common'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epms9112',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox
  },

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel'],
      epms9112Ref: 'epms9112Ref',
      gridMainList: [],
      shipNoList: [],
      porNoList: [],
      makerCd: this.$store.state.user.makerCd,
      shipNo: '',
      porNo: '' 
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms9112Ref)
    },
  },
  mounted() {
    this.getList()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.btnRetrieve()
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')
        let comParams = {
          makerCd: this.$store.state.user.makerCd
        }
        let params = {
          shipNo: this.shipNo,
          makerCd: this.$store.state.user.makerCd,
          delyNoteDiv : "",
          whDiv : "",
          incNotPo : "P"
        }
        await getShipNoList1(comParams).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })

        await epms9000_por_no(params).then(res => {
          this.porNoList.push('')
          res.list.forEach(e => {
            this.porNoList.push(e.porNo)
          });
          this.porNo = this.porNoList[0] ;
        })

      } finally {
      this.endLoading()
      }
    },
    async getPorNoList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
          makerCd: this.$store.state.user.makerCd,
          delyNoteDiv : "",
          whDiv : "",
          incNotPo : "P"
        }
        await epms9000_por_no(params).then(res => {
          this.porNoList.push('')
          res.list.forEach(e => {
            this.porNoList.push(e.porNo)
          });
          this.porNo = this.porNoList[0] ;
        })
      } finally {
        this.endLoading()
      }
    },
    async getMainList(){
      try {
        this.openLoading('searching')

        let params = {
          makerCd: this.$store.state.user.makerCd,
          shipNo : this.shipNo,
          porNo  : this.porNo == 'All' || !this.porNo ? '%' : this.porNoList[0],
        }
        
       // console.log("por No" + this.porNo)

        await epms9112(params).then(res => {
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            list.push(
              {

                id: cnt++ , no: e.no, shipNo: e.shipNo,  porNo : e.porNo, 
                lineNo: e.lineNo, dwgNo: e.dwgNo, block: e.block,  partNo: e.partNo, 
                dia: e.dia, pipeMatl: e.pipeMatl, treatCode: e.treatCode,  paintCode: e.paintCode, 
                cls: e.cls, insp: e.insp, press: e.press,  wgt: e.wgt
              }
            )
          });
          this.gridMainList = list
        })

      } finally {
      this.endLoading()
      }
    },
    shipNoChange(){
      this.getPorNoList()
    },
    porNoChange(){
      this.btnRetrieve()
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Pipe Piece List');

      exportDataGrid({
        component: this.gridMainInstance,
        worksheet,
        topLeftCell: { row: 1, column: 1 },
      }).then((cellRange) => {
        const headerRow = worksheet.getRow(1);
        const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
        const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
        let headerRowLength = headerRow._cells.length
        for(let i = 1; i <= headerRowLength; i++){
          headerRow.getCell(i).fill = headerStyle
          headerRow.getCell(i).border = headerBorderStyle
          headerRow.getCell(i).alignment = { horizontal: 'center' }
        }
        for(let j = 2; j <= worksheet._rows.length; j++){
          for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
            worksheet.getRow(j).getCell(a).border = headerBorderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Pipe Piece List.xlsx');
        });
      });
      this.gridMainInstance.cancel = true;
    },
    btnExcel(){
      this.openLoading('searching')
      const param = {
          makerCd: this.$store.state.user.makerCd,
          shipNo : this.shipNo,
          porNo  : this.porNo == 'All' || !this.porNo ? '%' : this.porNoList[0],
        }
      epms9112Xls(param)
      this.endLoading()
    },
    //cell merge
    // cellPrepared(e){
    //   if(e.rowType === 'data'){
    //     if(e.column.caption === 'No' || e.column.caption === 'Material Spec.') 
    //       {
    //         if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'no')){
    //           e.cellElement.setAttribute('rowspan', 2)
    //         }else {
    //           e.cellElement.style.display = 'none'
    //         }
    //     }
    //   } else {
    //     if(e.column.caption === 'Mon1'){
    //       e.cellElement.innerText = this.strMon1;
    //     }else if(e.column.caption === 'Mon2'){
    //       e.cellElement.innerText = this.strMon2;
    //     }else if(e.column.caption === 'Mon3'){
    //       e.cellElement.innerText = this.strMon3; 
    //     }else if(e.column.caption === 'Mon4'){
    //       e.cellElement.innerText = this.strMon4; 
    //     }else if(e.column.caption === 'Mon5'){
    //       e.cellElement.innerText = this.strMon5; 
    //     }
    //   }

    // },
    // getStrFormat(date) {
    //   return getDateFormat(date)
    // },
  }
}
</script>
<style lang="scss" scoped>
.epms9112-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  ::v-deep.text__dely-no {
    input {
      text-align: center;
    }
  }
}
</style>